<template>
  <div>
    <vue-html2pdf
      :show-layout="true"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="true"
      :paginate-elements-by-height="1400"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
      class="hidden"
    >
      <!--
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
       -->

      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <section class="pdf-item">
          <!-- Header START-->
          <div class="main-wrapper">
            <div class="header">
              <div class="logo">
                <logo class="logo cursor-pointer"/>
              </div>
              <div class="heading">Order Receipt</div>
            </div>
            <!-- Header END-->
            <!-- Section START-->
            <div class="receipt-section column">
              <div class="section-column">
                <div class="section-head">
                  <span>Ordered From:</span>
                  <span>{{ restaurant.user_property['Restaurant-Name'] }}</span>
                </div>
                <div class="section-cont">{{ restaurant.user_property['Address']}}</div>
              </div>
              <div class="section-column">
                <div class="section-head text-right">
                  <span>Order Date</span>
                  <span>{{ order.order_date }}</span>
                </div>
              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section column">
              <div v-if="order.delivery_type === 1" class="section-column">
                <div class="section-head">
                  <span>{{ (order.delivery_type_name === 'Delivery') ? 'Delivery To' : 'Pickup From' }} :</span>
                  <span>{{ order.customer.name }} {{ order.customer.last_name }}</span>
                </div>
                <div class="section-cont">
                  {{ order.address ? order.address : '' }} {{ order.address_disctrict }} {{ order.address_region }} {{ order.address_post_code }}<br>
                  {{ (order.address_phone) ? order.address_phone : ''}}
                </div>
              </div>
              <div v-else class="section-column">
                <div class="section-head">
                  <span>Pickup From</span>
                  <span>{{ restaurant.user_property['Restaurant-Name'] }}</span>
                </div>
                <div class="=section-cont">
                  {{ restaurant.user_property['Address'] }}<br>
                  {{ (restaurant.phone) ? restaurant.phone : ''}}
                  <br/>
                </div>
              </div>
              <div class="section-column">
                <div class="section-head">
                  <span>Billed To</span>
                  <span>{{ order.customer.name }} {{ order.customer.lastname }}</span></div>
                <div class="section-cont">
                  {{ order.address }}, {{ order.address_disctrict }} {{ order.address_region }}, {{ order.address_post_code }}<br>
                  {{ (order.address_phone) ? order.address_phone : ''}}
                </div>
              </div>
              <div class="section-column">
                <div class="section-head">
                  <span>Order Number #:</span>
                  <span>{{ order.id }}</span></div>
              </div>
              <div class="section-column">
                <div class="section-head">
                  <span>Payment Method:</span>
                  <span>{{ order.payment_type }}</span></div>
              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section">
              <div class="section-head"><span>Your Order:</span></div>
              <div class="order-items" v-if="order.orderProduct.length">
                <div class="item" :class="(item.modifier.length > 0) ? 'has-extra' : ''" v-for="(item, index) in order.orderProduct" :key="index">
                  <div class="item-name">{{item.quantity ? item.quantity : '1'}} {{item.product_name}}</div>
                  <div class="item-price">${{ formatPrice(item.price) }}</div>

                  <span class="extra-items" v-for="(mod, mod_index) in item.modifier" :key="mod_index">
                    <div class="item-name extra">{{ mod.modifier_item_name }}</div>
                    <div class="item-price">${{ formatPrice(mod.price) }}</div>
                  </span>
                </div>

              </div>
            </div>
            <!-- Section END-->
            <!-- Section START-->
            <div class="receipt-section subtotal">
              <div class="total">
                <div class="item">
                  <div class="item-name">Items Subtotal:</div>
                  <div class="item-price">${{ formatPrice(order.orderProduct.reduce((a, b) => { return a + b['totalPrice'] }, 0)) }}</div>
                </div>
                <div class="item">
                  <div class="item-name">Delivery Fee</div>
                  <div class="item-price">Free</div>
                </div>
                <div class="item">
                  <div class="item-name">Sales Tax</div>
                  <div class="item-price">${{ order.tax }}</div>
                </div>
                <div class="item">
                  <div class="item-name">Service Fee</div>
                  <div class="item-price">-</div>
                </div>
                <div class="item last-item">
                  <div class="item-name">Tip</div>
                  <div class="item-price">${{ order.tip_price }}</div>
                </div>
                <div class="grand-total">
                  <div class="item-name">TOTAL:</div>
                  <div class="item-price">${{ order.total_amount }}</div>
                </div>

              </div>
            </div>
            <!-- Section END-->
            <div class="brand">© Turkish Restaurant LLC.<br>267 Fifth Avenue, 310, New York, NY 10016, USA</div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Logo from '../../../src/layouts/components/Logo'

export default {
  props: {
    order: {
      type: Object
    },
    filename: {
      type: String
    }
  },
  name: 'printPdfTemplate',
  components: {
    VueHtml2pdf,
    Logo
  },
  computed: {
    restaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  mounted () {
    this.generateReport()
  },
  methods: {
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    calculatePrice (priceitem) {
      const item = JSON.parse(JSON.stringify(priceitem))
      if (item.size) {
        item.price = item.size.selected_value.price
      }
      if (item.modifier.length > 0) {
        item.modifier.forEach(function (key) {

          if (typeof key.modifier.selected_value !== 'undefined') {
            if (Array.isArray(key.modifier.selected_value)) {
              key.modifier.selected_value.forEach(function (mod_val) {
                item.price = Number(item.price) + Number(mod_val.price)
              })
            } else {
              item.price = Number(item.price) + Number(key.modifier.selected_value.price)
            }

          }
        })
      }
      return item.price * item.quantity
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
      setTimeout(() => {
        this.close()
      }, 500)
    },
    close () {
      // destroy the vue listeners, etc
      this.$destroy()

      // remove the element from the DOM
    }
  }
}
</script>

<style lang="scss">
blockquote,
body,
dd,
dl,
dt,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
html,
iframe,
legend,
li,
ol,
p,
pre,
textarea,
ul {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
ul {
  list-style: none;
}
button,
input,
select {
  margin: 0;
}
html {
  box-sizing: border-box;
}
*,
::after,
::before {
  box-sizing: inherit;
}
img,
video {
  height: auto;
  max-width: 100%;
}
iframe {
  border: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
.main-wrapper{
  width:100%;
  margin:0 auto;
  padding:20px;
}
.header, .receipt-section.column, .item, .grand-total {
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.logo {
  width:200px;
  height:auto;
}
.heading {
  font-size:24px;
  font-weight: bold;
}
.receipt-section {
  padding:20px 0;
  border-bottom:2px solid #000;
}
.section-head {
  margin-bottom:5px;
}
.section-head span {
  display:block;
}
.section-head span:first-child{
  font-weight: bold;
}
.section-head span:nth-child(2){
  font-size:24px;
  font-weight: bold;
}
.section-cont {
  line-height:25px;
}
.column .section-column{
  flex:50%;
  margin-bottom:20px;
}
.item {
  padding:10px;
  border-bottom:1px dashed #333;
}
.grand-total{
  padding:10px;
  font-weight: bold;
}
.item:last-child{
  border:none;
}
.extra-items {
  flex: 100%;
  display: flex;

  div {
    flex: 50%;
  }
}
.has-extra div{
  flex:50%;
  margin-bottom:5px;
}
.has-extra .item-price {
  text-align:right;
}
.item-name.extra {
  padding-left:20px;
}
.total {
  width:50%;
}
.total .item {
  border-bottom:none;
}
.total .last-item{
  border-bottom:2px solid #000;
  margin-bottom:10px;
}
.receipt-section.subtotal{
  border:none;
  display:flex;
  flex-direction: row-reverse;
}
.brand {
  text-align:center;
  font-size:12px;
  margin-top:50px;
}
</style>
